import Api from '../../api'
import {
  call,
  put,
  takeLatest,
  takeEvery,
  select,
  all,
} from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from '../create-request-saga'
// Importing constants
import { COLLEEN_PAYMENT_LINK_ID } from 'portal-modules/common/constants/keys'
// Importing Utility Functions
import getPaymentSourceCondition from 'portal-modules/common/utils/get-payment-source-condition'
import { getDecryptedCryptoData } from 'portal-modules/common/utils/crypto-encryption'
// action types
export const REQUEST_BALANCE_DUE = 'rp/balanceDue/REQUEST_BALANCE_DUE'
export const REQUEST_MULTIPLE_BALANCE_DUE =
  'rp/balanceDue/REQUEST_MULTIPLE_BALANCE_DUE'
export const RECEIVE_BALANCE_DUE = 'rp/balanceDue/RECEIVE_BALANCE_DUE'
export const RESET_BALANCE_DUE = 'rp/balanceDue/RESET_BALANCE_DUE'
const REQUEST_FUTURE_CHARGES = 'rp/balanceDue/REQUEST_FUTURE_CHARGES'
const RECEIVE_FUTURE_CHARGES = 'rp/balanceDue/RECEIVE_FUTURE_CHARGES'

// Checking payment source condition for colleen payment
const { isColleenPayment } = getPaymentSourceCondition();

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_BALANCE_DUE:
      // Adding logic for future option is been overriden by the balance due payload
      var response = {}
      if (state?.future) {
        response.future = { ...state.future }
      }
      return { ...response, ...payload }
    case RECEIVE_FUTURE_CHARGES:
      return { ...state, ...payload }
    case RESET_BALANCE_DUE:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestBalanceDue = callback => ({
  type: REQUEST_BALANCE_DUE,
  callback,
})

export const requestMultipleBalanceDue = payload => ({
  type: REQUEST_MULTIPLE_BALANCE_DUE,
  payload,
})

export const receiveBalanceDue = payload => ({
  type: RECEIVE_BALANCE_DUE,
  payload,
})

export const requestFutureCharges = payload => ({
  type: REQUEST_FUTURE_CHARGES,
  payload,
})

export const resetBalanceDue = () => ({
  type: RESET_BALANCE_DUE,
})

// sagas
export function* fetchBalanceDue({ callback }) {
  let API_BALANCE = Api.getLeaseBalance
  // Adding this payload value only for Colleen payment to get is_link_expired flag
  const API_PAYLOAD = isColleenPayment
    ? { payment_link_id: parseInt(getDecryptedCryptoData(COLLEEN_PAYMENT_LINK_ID)) || 0 }
    : undefined;

  if (window.rpSettings.projectName == 'rh') {
    API_BALANCE = Api.getContractBalance
  }

  let data = ''
  if (typeof callback === 'object') {
    data = yield call(Api.getLeaseBulkBalance, callback)
  } else {
    
    data = yield call(API_BALANCE, API_PAYLOAD)
  }

  if (window.rpSettings.projectName == 'rh' && 'current_balance' in data) {
    data['total_balance'] = data['current_balance']
  }

  if (typeof callback === 'object') {
    let reduxBalance = 0
    let leaseBalance = {}
    yield select(({ balanceDue }) => {
      reduxBalance = (balanceDue && balanceDue.total_balance) || 0
      leaseBalance = (balanceDue && balanceDue.lease_balance) || {}
    })

    data['lease_balance'] = {
      ...leaseBalance,
      [`${callback.leaseId}`]: data['total_balance'],
    }
    data['total_balance'] =
      data?.lease_balance &&
      Object.values(data?.lease_balance).reduce(
        (total, balance) => total + parseFloat(balance),

        0,
      )
  }
  yield put(receiveBalanceDue(data))
  typeof callback === 'function' && callback(data)
}

function* fetchMultipleBalanceDue({ payload: { leases } }) {
  yield all(
    leases &&
      Object.keys(leases).length &&
      Object.keys(leases).map(id =>
        call(fetchBalanceDue, {
          callback: { token: leases?.[id], leaseId: id },
        }),
      ),
  )
}

function* watchRequestBalanceDue() {
  yield takeLatest(
    REQUEST_BALANCE_DUE,
    createRequestSaga(fetchBalanceDue, {
      key: 'balanceDue',
      message: __('Looking up your balance'),
    }),
  )
}

function* watchRequestMutipleBalanceDue() {
  yield takeLatest(
    REQUEST_MULTIPLE_BALANCE_DUE,
    createRequestSaga(fetchMultipleBalanceDue, {
      key: 'balanceDue',
      message: __('Looking up your balance'),
    }),
  )
}

export function* fetchFutureCharges({ payload: { callback } = {} }) {
  const data = yield call(Api.getFutureCharges)
  yield put({
    type: RECEIVE_FUTURE_CHARGES,
    payload: { future: data },
  })
  if (typeof callback === 'function') yield call(callback, data)
}

function* watchRequestFutureCharges() {
  yield takeLatest(
    REQUEST_FUTURE_CHARGES,
    createRequestSaga(fetchFutureCharges, {
      key: 'futureCharges',
      message: __('Looking up your balance'),
    }),
  )
}

export const sagas = [
  watchRequestBalanceDue,
  watchRequestFutureCharges,
  watchRequestMutipleBalanceDue,
]
